/***
 * @file:åè¡¨åºç¡
 * @author: linkun.he
 * @Date: 2019-06-03 10:29:27
 */
import { Injector, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { PermissionsService, SettingsService, TenantService } from '@ithinkdt/shared/browser';
import { ConfirmService } from '@ithinkdt/shared/confirm';
import { I18NService } from '@ithinkdt/shared/i18n';
import { DtMessageService } from '@ithinkdt/shared/message';
import { COMMON_COMFIG } from '@ithinkdt/shared/utils';
import { cloneDeep, isEqual } from 'lodash';
import { NzModalService } from 'ng-zorro-antd/modal';

import { DataSet, Sort, TableParam } from './table.interface';
import { TableService } from './table.service';

export abstract class BaseTablePage implements OnInit {
  oprCodes: any; // æææä½çcodeç ï¼æé®æéæ§å¶ä½¿ç¨
  isLoading = false; // è¡¨æ ¼æ°æ®æ¯å¦å è½½ç¶æ
  allChecked = false; // ç¨æ·åè¡¨å¨éç¶æ
  indeterminate = false; // ç¨æ·åè¡¨é¨åéæ©ç¶æ
  radioChooseData: any; // radio éä¸­çæ°æ®
  radioChooseByKey = 'id';
  sortparam: Sort = cloneDeep(COMMON_COMFIG.DEFAULT_SORT); // æåºåæ°
  paginationParam: TableParam = cloneDeep(COMMON_COMFIG.DEFAULT_TABLE); // åé¡µåæ°
  searchParam: object; // æç´¢æ¡ä»¶
  tableData: any[] = []; // è¡¨æ ¼æ°æ®
  tableDataTotal: string | number; // æ°æ®æ»æ°
  deleteKey = ''; // å é¤æ¶ä¼ éç»åç«¯çkey
  deleteConfirmSub: Subscription; // å é¤ç¡®è®¤äºä»¶çå¬
  pageService; // é¡µé¢çæå¡ï¼åå«è¡¨æ ¼æ°æ®è¯·æ±

  isEqual = isEqual;

  get multiTenantMode(): boolean {
    return this.TenantSrv.multiTenantMode;
  }

  get isPlatformAdmin(): boolean {
    return this.TenantSrv.isPlatformAdmin;
  }

  protected i18nSrv: I18NService; // å½éå
  protected tableSrv: TableService; // è¡¨åæå¡
  protected modalSrv: NzModalService; // æ¨¡ææ¡
  protected messageSrv: DtMessageService; // æ¶æ¯æé
  protected confirmSrv: ConfirmService; // ç¡®è®¤æ¡
  protected settingsSrv: SettingsService; // ç¨æ·è®¾ç½®æå¡
  protected permissionsSrv: PermissionsService; // æéæå¡
  protected TenantSrv: TenantService; // ç§æ·æå¡

  constructor(public inj: Injector) {
    this.i18nSrv = this.inj.get(I18NService);
    this.tableSrv = this.inj.get(TableService);
    this.modalSrv = this.inj.get(NzModalService);
    this.messageSrv = this.inj.get(DtMessageService);
    this.confirmSrv = this.inj.get(ConfirmService);
    this.settingsSrv = this.inj.get(SettingsService);
    this.permissionsSrv = this.inj.get(PermissionsService);
    this.TenantSrv = this.inj.get(TenantService);

    this.oprCodes = this.settingsSrv.userConfig.env.oprCodes || {};
  }

  ngOnInit() {
    if (this.ngOnInitReserved() === false) {
      return;
    }
    this.getTableData();
  }

  // è·ååè¡¨æ°æ®
  getTableData() {
    this.resetTemp();
    const param = Object.assign({}, this.paginationParam, this.searchParam, this.sortparam);
    this.isLoading = true;
    this.pageService.getTableData(param).subscribe((res: DataSet) => {
      if (this.setTableDataReserved(res) === false) {
        return;
      }
      this.setTableData(res);
    });
  }

  /**
   * @todo è¡¨æ ¼è¯·æ±æ¹æ³
   * @param data æ ¹æ®è¯·æ±è·å¾çæ°æ®ï¼å¡«åè¡¨æ ¼åå®¹
   */
  setTableData(res: DataSet) {
    if (res.status) {
      this.tableData = res.data;
      this.tableDataTotal = res.record;
    }
    this.isLoading = false;
  }

  /**
   * @todo æç´¢
   * @param data æç´¢è¡¨åçæ°æ®
   */
  search(data?) {
    this.searchParam = data;
    if (this.searchReserved(data) === false) {
      return;
    }
    this.paginationParam.pageNumber = COMMON_COMFIG.DEFAULT_TABLE.pageNumber;
    this.getTableData();
  }

  /**
   * åæ¢é¡µç 
   * @param index å½åçé¡µç æ°
   */
  pageIndexChange(index: number) {
    if (this.pageIndexChangeReserved(index) === false) {
      return;
    }
    this.paginationParam.pageNumber = index;
    this.getTableData();
  }

  /**
   * @todo åæ¢æ¯é¡µæ¾ç¤ºä¸ªæ°
   * @param size åé¡µä¸­é¡µé¢æ¾ç¤ºä¸ªæ°
   */
  pageSizeChange(size: number) {
    if (this.pageSizeChangeReserved(size) === false) {
      return;
    }
    this.paginationParam.pageSize = size;
    this.getTableData();
  }

  /**
   * @todo æåº
   * @param sort åºå®åæ³
   *        key {string} æåºçé®
   *        value {string} æåºè§å
   */
  sort(sort: { key: string; value: string }) {
    if (this.sortReserved(sort) === false) {
      return;
    }
    this.sortparam = this.tableSrv.getSortData(sort);
    this.getTableData();
  }

  // å·æ°è¡¨æ ¼çå¨éåé¨åéæ©çç¶æ
  refreshStatus() {
    const status = this.tableSrv.getCheckedStatus(this.tableData);
    this.allChecked = status.allChecked;
    this.indeterminate = status.indeterminate; // é¨åéä¸­
  }

  // éç½®åé
  resetTemp() {
    this.allChecked = false;
    this.indeterminate = false;
  }

  resetTable() {
    this.paginationParam = cloneDeep(COMMON_COMFIG.DEFAULT_TABLE);
    this.resetTemp();
  }

  /**
   * è¡¨åå¨éæèå¨ä¸éï¼æ´æ¹è¡¨æ ¼è¡æ°æ®çè¢«éç¶æ
   * @param value å½åéæ©ç¶æ
   */
  checkAll(value: boolean) {
    if (this.checkAllReserved(value) === false) {
      return;
    }
    this.tableData
      .filter((item) => !item.disabled)
      .forEach((data) => {
        data.checked = value;
      });
    this.refreshStatus();
  }

  // radioéæ©åååè°
  radioChooseChange(newChoosedData) {
    this.radioChooseData = newChoosedData;
  }

  /********************************************************************************
   *
   *  ä»¥ä¸æ¹æ³ä¸ºé¢çæ¹æ³ï¼è¥base-tableæä¾çæ¹æ³ä¸è¶³ä»¥æ»¡è¶³éæ±ï¼å¯å¨å­ç±»ä¸­è¦çå¦ä¸æ¹æ³ã
   *  å¨è¦ççæ¹æ³ä¸­ï¼è¿åtrueåå¶ä»æ¹æ³ä¹ä¼æ§è¡ï¼è¿åfalseååªä¼æ§è¡è¦ççæ¹æ³ã
   *
   *  å¦ï¼
   *     å¨å­ç±»åªè½ä¸­å®ç°äº`setTableDataReserved`æ¹æ³å¹¶è¿åäºfalseï¼å`setTableData()`
   *     æ¹æ³éé¢çå¶ä»jsä¸ä¼æ§è¡ï¼åªæ§è¡å®ä¹ç`setTableDataReserved`æ¹æ³ã
   *
   ********************************************************************************/
  /***
   * @todo è¯·æ±è¡¨æ ¼æ°æ®æ¹æ³é¢ç
   * @desc å¼åèå¯è¦çæ­¤æ¹æ³å®ç°èªå®ä¹, è¥è¿åfalseåä¸è°ç¨èªå¸¦çå¤çæ¹æ³ setTableData
   */

  ngOnInitReserved(): boolean {
    return true;
  }

  setTableDataReserved(res: DataSet): boolean {
    return true;
  }

  /***
   * @todo æç´¢é¢ç
   * @desc å¼åèå¯è°ç¨æ­¤æ¹æ³å®ç°èªå®ä¹, è¥è¿åfalseåä¸è°ç¨èªå¸¦çå¤çæ¹æ³ search
   */

  searchReserved(data: object): boolean {
    return true;
  }

  /**
   * @todo åæ¢é¡µç é¢ç
   * @desc å¼åèå¯è°ç¨æ­¤æ¹æ³å®ç°èªå®ä¹, è¥è¿åfalseåä¸è°ç¨èªå¸¦çå¤çæ¹æ³ pageIndexChange
   */
  pageIndexChangeReserved(index: number): boolean {
    return true;
  }

  /**
   * @todo åæ¢æ¯é¡µæ¾ç¤ºä¸ªæ°é¢ç
   * @desc å¼åèå¯è°ç¨æ­¤æ¹æ³å®ç°èªå®ä¹, è¥è¿åfalseåä¸è°ç¨èªå¸¦çå¤çæ¹æ³ pageSizeChange
   */
  pageSizeChangeReserved(size: number): boolean {
    return true;
  }

  /**
   * @todo æåºé¢ç
   * @desc å¼åèå¯è°ç¨æ­¤æ¹æ³å®ç°èªå®ä¹, è¥è¿åfalseåä¸è°ç¨èªå¸¦çå¤çæ¹æ³ sort
   */
  sortReserved(sort: { key: string; value: string }): boolean {
    return true;
  }

  /**
   * @todo è¡¨åå¨éæèå¨ä¸é é¢ç
   * @desc å¼åèå¯è°ç¨æ­¤æ¹æ³å®ç°èªå®ä¹, è¥è¿åfalseåä¸è°ç¨èªå¸¦çå¤çæ¹æ³ sort
   */
  checkAllReserved(value: boolean): boolean {
    return true;
  }

  /********************************************************************************
   *
   *  ä¸äºæä½
   *
   ********************************************************************************/

  /**
   * åä¸ªå é¤
   * this.deleteKeyï¼ å é¤æ¶ä¼ éå°åç«¯çé®
   * @param id è¢«å é¤ç¨æ·idæèå¶ä»æ å¿
   */
  delete(id) {
    this.confirmSrv.confirm(this.i18nSrv.interpret('operations.delete.confirm'), () => {
      this.pageService.deleteTableData({ [this.deleteKey]: id }).subscribe((res) => {
        if (res.status) {
          this.messageSrv.success('operations.delete.succ');
          this.getTableData();
        }
      });
    });
  }

  /**
   * å¤ä¸ªå é¤
   * @param key ä»è¡¨æ ¼æ°æ®ä¸­è¦åå¼å¾é®
   * this.tableData = [{id: 1}]
   * åkeyæ¯id,è¥keyåthis.deleteKeyç¸ååå¯ä»¥ä¸ä¼ 
   */
  multiDelete(key?) {
    key = key || this.deleteKey;
    this.delete(this.tableSrv.getCheckedIds(this.tableData, key));
  }

  /********************************************************************************
   *
   *  è¡¨æ ¼åäºä»¶è§¦åå¨
   *
   ********************************************************************************/
  // triggerInnerOprFunc(arg: any = { data: null, func: function() {} }) {
  //   const { data, func } = arg;
  //   this[func](data);
  // }
}
